export default "__VITE_ASSET__Bgye0ybI__"